import React from 'react';
import '../styles/legal.css';

const LegalSection = ({ title, children }) => {
  return (
    <section className="legal-section container">
      <h1>{title}</h1>
      {children}
    </section>
  );
};

export default LegalSection;